<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>Importar CDFI's</h5>
                <form [formGroup]="formCfdi">
                    <mat-radio-group color="primary" [(ngModel)]="radioActive" [ngModelOptions]="{standalone: true}">

                        <mat-radio-button [value]="1" (change)="radioChange($event)">
                            Folio Fiscal <span class="req">*</span>
                        </mat-radio-button>
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-xl-12 ">
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <input matInput (input)="lowerCase('uuid', $event);" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" 
                                        formControlName="uuid" minlength="36" maxlength="36">
                                        <mat-error *ngIf="(this.f['uuid'].errors?.['required'])"><strong>*Este
                                                campo es obligatorio</strong></mat-error>
                                                <mat-error *ngIf="(this.f['uuid'].errors?.['pattern'])"><strong>Folio</strong> no es válido.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                        <mat-radio-button [value]="2" (change)="radioChange($event)">
                            Buscar por:
                        </mat-radio-button>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>Fecha Inicial de Emisión <span class="req">*</span></mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <input matInput [min]="minDate" [max]="today" [matDatepicker]="picker1"
                                            formControlName="fechaInicial" (dateChange)="dateChange($event)" readonly (click)="picker1.open()">
                                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker1 color="primary"></mat-datepicker>
                                    </mat-form-field>

                                </div>

                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>Fecha Final de Emisión <span class="req">*</span></mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <input matInput [min]="minDate2" [max]="today" [matDatepicker]="picker2"
                                            formControlName="fechaFinal" readonly (click)="picker2.open()">
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2 color="primary"></mat-datepicker>
                                    </mat-form-field>

                                </div>

                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>RFC Receptor</mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <input matInput  placeholder="" minlength="8"
                                            (input)="upperCase('rfcReceptor', $event);" maxlength="13"
                                            formControlName="rfcReceptor">
                                        <mat-error *ngIf="(this.f['rfcReceptor'].errors?.['pattern'])">El
                                            <strong>RFC</strong> no es válido.</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>Tipo de Comprobante</mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <mat-select name="tipoComprobante" placeholder="Seleccione"
                                            formControlName="tipoComprobante">
                                            <mat-option>Todos</mat-option>
                                            <mat-option *ngFor="let atr of tiposComprobantes" [value]="atr.id">
                                                {{ atr.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- <mat-label>RFC a cuenta terceros</mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <input matInput  placeholder="" formControlName="rfcEmisor">
                                        <mat-error *ngIf="(this.f['rfcEmisor'].errors?.['pattern'])">El
                                            <strong>RFC</strong> no es válido.</mat-error>
                                    </mat-form-field> -->
                                </div>

                                <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>Estado del Comprobante</mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <mat-select name="estadoComprobante" placeholder="Seleccione"
                                            formControlName="estadoComprobante">
                                            <mat-option>Todos</mat-option>
                                            <mat-option *ngFor="let edo of estatusComprobantes" [value]="edo.id">
                                                {{ edo.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <!-- <div class="col-sm-12 col-md-6 col-xl-6">
                                    <mat-label>Tipo de Comprobante</mat-label>
                                    <mat-form-field class="custom-field" appearance="outline">
                                        <mat-select name="tipoComprobante" placeholder="Seleccione"
                                            formControlName="tipoComprobante">
                                            <mat-option>Todos</mat-option>
                                            <mat-option *ngFor="let atr of tiposComprobantes" [value]="atr.id">
                                                {{ atr.attributes.nombre }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> -->
                            </div>
                        
                    </mat-radio-group>

                </form>

                <!-- <div class="col-12">
                    <div class="flex align-items-center justify-content-center">
                        {{this.formCfdi.value | json}}
                        {{this.radioActive | json}}
                    </div>
                </div>  -->
            </mat-card-content>

        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button mat-flat-button color="accent" [disabled]="!formCfdi.valid" cdkFocusInitial (click)="search();">Burcar
        CFDI</button>

</div>